import axios from 'axios'
export default{
    state:{
        itemspermisos:[],
        permisosasignados:[],
        encontrado:false,
    },
    mutations:{
        setAllModulos(state,items){
            state.itemspermisos = items
        },
        setUsuarioPermisos(state,modulos){
            state.permisosasignados =modulos
        }
    },
    actions:{
        async setAllModulos({commit,rootState,getters}){
          await  axios.get(`${rootState.urlapi}/modulos`,getters.getTokenUser).then(res=>{
             //   console.log(res.data)
                commit("setAllModulos",res.data)
            })
        },
        async setUsuarioPermisos({commit,rootState,getters},username){
           await axios.get(`${rootState.urlapi}/usuarios/permisos/${username}`,getters.getTokenUser).then(res=>{
                commit("setUsuarioPermisos",res.data)
            })
        }
    },
    getters:{
        getModulos(state){
            return state.itemspermisos
        },
        getOnePermiso: (state) => (item) =>{
            return state.itemspermisos.find(element => element.idpermiso == item.idpermiso)
        },
        getPermisosAsignados(state){
            return state.permisosasignados
        }
    }
}